import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errMsg } from "@/lib/api";
import { AuthShell } from "@/pages/AuthShell";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [token, setToken] = useState("");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setMsg(data.message);
      if (data.reset_token) setToken(data.reset_token);
    } catch (err) {
      setError(errMsg(err));
    }
  };

  return (
    <AuthShell
      title="Reset your password"
      subtitle="We'll issue a secure reset link for your account."
      footer={<Link className="font-semibold text-primary" to="/login" data-testid="back-to-login-link">Back to log in</Link>}
    >
      <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
        <div className="space-y-2">
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                 data-testid="forgot-email-input" />
        </div>
        {error && <p className="rounded-md bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="forgot-error">{error}</p>}
        <Button type="submit" className="w-full rounded-full" data-testid="forgot-submit-btn">Send reset link</Button>
        {msg && (
          <div className="rounded-md border border-border bg-white p-3 text-sm" data-testid="forgot-success">
            <p>{msg}</p>
            {token && (
              <Link to={`/reset-password?token=${token}`} className="mt-2 inline-block font-semibold text-primary"
                    data-testid="reset-link">
                Continue to reset password
              </Link>
            )}
          </div>
        )}
      </form>
    </AuthShell>
  );
}
